import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

// Appends a level to a Unit Upgrade track, copying the last level's numbers (a first level: 10 gold,
// 2 turns, +1) so a ladder is quick to author.
export class AddUnitUpgradeLevelCommand extends CommandBase {
    uid: string;

    constructor(uid: string) {
        super();
        this.uid = uid;
    }

    execute(data: RemoteConstantsModel): boolean {
        const track = data.unitUpgrades?.find(t => t.uid === this.uid);
        if (!track) return false;
        const last = track.levels[track.levels.length - 1];
        track.levels = [...track.levels, last ? {...last} : {price: 10, turns: 2, amount: 1}];
        return true;
    }
}
